import React, { useState, useCallback, useEffect } from "react";

import TemplateIndex from "../../components/TemplateIndex";
import { ICardMenu } from "../../components/CardMenu";

import DynamicRepository from "../../Repositories/DynamicRepository";
import { RouteComponentProps } from "react-router-dom";
import { Roles } from "../../interfaces";
import { GetUser } from "../../services/auth";

interface IState {
    M01: number;
    M02: number;
    M03: number;
    M04: number;
    M05: number;
    M06: number;
    M07: number;
    M08: number;
    M09: number;
    M10: number;
    M11: number;
    M12: number;
}

interface ILocationState {
    status: number;
}

const ConferenceRepresentante: React.FC<RouteComponentProps<any, any, ILocationState>> = ({ location }) => {

    const initialState: IState = {
        M01: 0,
        M02: 0,
        M03: 0,
        M04: 0,
        M05: 0,
        M06: 0,
        M07: 0,
        M08: 0,
        M09: 0,
        M10: 0,
        M11: 0,
        M12: 0
    }

    const [state, setState] = useState<IState>(initialState);

    const whichPath = useCallback((role: Roles) => {
        switch (role) {
            case "Admin":
            case "Operador":
                return `/conferencelist`;
            case "GerenteR":
                return `/conferencesectors`;
            case "GerenteS":
                return `/conferenceagents`;
            case "Representante":
                return `/conferencelist`;
            default:
                return `/`;
        }
    }, []);

    const loadKitsToConference = useCallback(async () => {
        const response = await DynamicRepository.DynamicTotals([
            {
                dynamicType: "KM",
                returnCode: "M01",
                filter: `1,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M02",
                filter: `2,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M03",
                filter: `3,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M04",
                filter: `4,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M05",
                filter: `5,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M06",
                filter: `6,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M07",
                filter: `7,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M08",
                filter: `8,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M09",
                filter: `9,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M10",
                filter: `10,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M11",
                filter: `11,${location.state.status}`
            },
            {
                dynamicType: "KM",
                returnCode: "M12",
                filter: `12,${location.state.status}`
            }
        ]);

        setState({
            M01: response.M01,
            M02: response.M02,
            M03: response.M03,
            M04: response.M04,
            M05: response.M05,
            M06: response.M06,
            M07: response.M07,
            M08: response.M08,
            M09: response.M09,
            M10: response.M10,
            M11: response.M11,
            M12: response.M12,
        });

    }, [location.state.status]);

    useEffect(() => {
        loadKitsToConference();
    }, [loadKitsToConference]);

    const items: ICardMenu[] = [
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 1
                }
            },
            icon: "calendar alternate outline",
            text: "Janeiro",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M01 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 2
                }
            },
            icon: "calendar alternate outline",
            text: "Feveireiro",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M02 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 3
                }
            },
            icon: "calendar alternate outline",
            text: "Março",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M03 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 4
                }
            },
            icon: "calendar alternate outline",
            text: "Abril",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M04 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 5
                }
            },
            icon: "calendar alternate outline",
            text: "Maio",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M05 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 6
                }
            },
            icon: "calendar alternate outline",
            text: "Junho",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M06 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 7
                }
            },
            icon: "calendar alternate outline",
            text: "Julho",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M07 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 8
                }
            },
            icon: "calendar alternate outline",
            text: "Agosto",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M08 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 9
                }
            },
            icon: "calendar alternate outline",
            text: "Setembro",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M09 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 10
                }
            },
            icon: "calendar alternate outline",
            text: "Outubro",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M10 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 11
                }
            },
            icon: "calendar alternate outline",
            text: "Novembro",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M11 > 0
        },
        {
            path: {
                pathname: whichPath(GetUser().role),
                state: {
                    status: location.state.status,
                    month: 12
                }
            },
            icon: "calendar alternate outline",
            text: "Dezembro",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: state.M12 > 0
        },
    ];

    return <TemplateIndex title="Selecione um mês" cards={items} />;
};

export default ConferenceRepresentante;
